import React, { Component } from "react";
import styled from "styled-components";
import { Drawer, Button, toaster, Notification, Row, Col } from "rsuite";
import { createStructuredSelector } from "reselect";
import { HistorySelector } from "../redux/selector";
import { SetHistory } from "../redux/actions";
import { connect } from "react-redux";
import { position } from "dom-helpers";

const Logo = styled.img`
  width: 25px;
  transition: 100ms;
  &:active {
    transform: scale(0.85);
  }
`;
const DrawerBox = styled.div`
  padding: 15px;
`;
const HistoryItem = styled.div`
  width: 100%;
  height: 42px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: space-between;
  margin-bottom: 5px;
  padding: 7px;
  background-image: url(/assets/new_form.png);
  background-size: contain;
  background-repeat: no-repeat;
  text-align: center;
`;
const Detail = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const NotificationDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  min-width: 200px;
`;

class HistoryComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
    };
  }

  handleClearHistory = () => {
    const { setHistory } = this.props;
    toaster.push(
      <Notification type="warning" header="پاک کردن تاریخچه">
        <NotificationDiv>
          <p style={{ marginBottom: "7px" }}>
            از پاک کردن تاریخچه پیام های ارسالی مطمئن هستید؟
          </p>
          <Row>
            <Col xs={12}>
              <Button
                block
                appearance="primary"
                color="red"
                onClick={() => {
                  setHistory([]);
                  toaster.remove();
                }}
              >
                بلی
              </Button>
            </Col>
            <Col xs={12}>
              <Button
                block
                onClick={() => {
                  toaster.remove();
                }}
              >
                خیر
              </Button>
            </Col>
          </Row>
        </NotificationDiv>
      </Notification>,
      { placement: "topEnd" }
    );
  };

  render() {
    const { show } = this.state;
    const { history } = this.props;
    const sound = new Audio("/assets/click.mp3");
    return (
      <div>
        <Logo
          src="/assets/new_inbox.png"
          alt="setting"
          onClick={() => {
            sound.play();
            this.setState({ show: true });
          }}
        />
        <Drawer
          open={show}
          onClose={() => this.setState({ show: false })}
          size="xs"
          style={{ maxWidth: "300px", borderLeft: "1px solid darkorange" }}
          placement="left"
        >
          <Drawer.Header>
            <Drawer.Title>تاریخچه دستورات</Drawer.Title>
          </Drawer.Header>
          <DrawerBox>
            {!!history.length ? (
              history.reverse().map((item, i) => (
                <HistoryItem key={i}>
                  <small style={{ color: "orange" }}>{item.date}</small>
                  <Detail>
                    <small>{item.text}</small>
                    <small>{item.device}</small>
                  </Detail>
                </HistoryItem>
              ))
            ) : (
              <p>اطلاعاتی ثبت نشده</p>
            )}
          </DrawerBox>
          {!!history.length && history.length > 10 && (
            <Drawer.Footer>
              <Button
                block
                appearance="primary"
                color="orange"
                onClick={this.handleClearHistory}
              >
                پاک کردن تاریخچه
              </Button>
            </Drawer.Footer>
          )}
        </Drawer>
      </div>
    );
  }
}
const mapStateToProps = createStructuredSelector({
  history: HistorySelector,
});
const mapDispatchToProps = (dispatch) => ({
  setHistory: (data) => dispatch(SetHistory(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(HistoryComponent);
